import { TranslateFn } from '../hooks/context/useTranslate';

export const getExportOptions = (
  t: TranslateFn,
  onExport: (exportMode: string) => void
): { key: string; label: string; onClick: () => void }[] => [
  {
    key: 'main',
    label: t('export.mainRecords'),
    onClick: () => onExport('main'),
  },
  {
    key: 'with-subsets',
    label: t('export.mainRecordsWithSubsets'),
    onClick: () => onExport('with-subsets'),
  },
];
